export var cibMcafee = ["32 32", "<path d='M16 6.459l-13.855-6.417v25.5l13.855 6.417 13.855-6.417v-25.5zM24.208 21.917l-8.172 3.78-8.167-3.78v-12.98l8.167 3.781 8.172-3.781z'/>"];
